import { render, staticRenderFns } from "./DataCenterPie.vue?vue&type=template&id=aa5c84fc&scoped=true&"
import script from "./DataCenterPie.vue?vue&type=script&lang=js&"
export * from "./DataCenterPie.vue?vue&type=script&lang=js&"
import style0 from "./DataCenterPie.vue?vue&type=style&index=0&id=aa5c84fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5c84fc",
  null
  
)

export default component.exports